import {
  Stack,
  Paper,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { Fragment, type ReactNode } from "react";

interface ActionConfigBase {
  type: "save" | "node";
}

interface PredefinedAction extends ActionConfigBase {
  type: "save";
  onClick?: () => void;
  loading?: boolean;
}

interface NodeAction extends ActionConfigBase {
  type: "node";
  node: ReactNode;
}

export type TopAction = PredefinedAction | NodeAction;

interface Props {
  title?: string;
  actions: TopAction[];
}

export const StickyTopActions = ({ actions, title }: Props) => {
  return (
    <Paper
      sx={{
        width: "100%",
        p: 2,
        position: "sticky",
        top: 0,
        mb: "16px",
        zIndex: 1000,
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography
          variant="subtitle1"
          sx={(theme) => ({
            color: theme.palette.text.secondary,
          })}
        >
          {title}
        </Typography>

        <Stack direction={"row"} justifyContent={"end"}>
          {actions.map((it, idx) => (
            <Fragment key={`${idx}`}>
              {it.type === "save" && (
                <Button
                  disabled={it.loading}
                  onClick={it.onClick}
                  variant="contained"
                  sx={{ ml: "auto" }}
                  endIcon={
                    it.loading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  Save
                </Button>
              )}

              {it.type === "node" && it.node}
            </Fragment>
          ))}
        </Stack>
      </Stack>
    </Paper>
  );
};
